var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1394_41412",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1394_41412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 17.9167C4.83333 17.9167 4.47917 17.7709 4.1875 17.4792C3.89583 17.1875 3.75 16.8334 3.75 16.4167V8.58335C3.75 8.16669 3.89583 7.81252 4.1875 7.52085C4.47917 7.22919 4.83333 7.08335 5.25 7.08335H6.25V5.41669C6.25 4.37502 6.61444 3.48946 7.34333 2.76002C8.07278 2.03113 8.95833 1.66669 10 1.66669C11.0417 1.66669 11.9272 2.03113 12.6567 2.76002C13.3856 3.48946 13.75 4.37502 13.75 5.41669V7.08335H14.75C15.1667 7.08335 15.5208 7.22919 15.8125 7.52085C16.1042 7.81252 16.25 8.16669 16.25 8.58335V16.4167C16.25 16.8334 16.1042 17.1875 15.8125 17.4792C15.5208 17.7709 15.1667 17.9167 14.75 17.9167H5.25ZM5.25 16.6667H14.75C14.8194 16.6667 14.8786 16.6425 14.9275 16.5942C14.9758 16.5453 15 16.4861 15 16.4167V8.58335C15 8.51391 14.9758 8.45474 14.9275 8.40585C14.8786 8.35752 14.8194 8.33335 14.75 8.33335H5.25C5.18056 8.33335 5.12167 8.35752 5.07333 8.40585C5.02444 8.45474 5 8.51391 5 8.58335V16.4167C5 16.4861 5.02444 16.5453 5.07333 16.5942C5.12167 16.6425 5.18056 16.6667 5.25 16.6667ZM10 13.9584C10.4028 13.9584 10.7467 13.8161 11.0317 13.5317C11.3161 13.2467 11.4583 12.9028 11.4583 12.5C11.4583 12.0972 11.3161 11.7534 11.0317 11.4684C10.7467 11.1839 10.4028 11.0417 10 11.0417C9.59722 11.0417 9.25333 11.1839 8.96833 11.4684C8.68389 11.7534 8.54167 12.0972 8.54167 12.5C8.54167 12.9028 8.68389 13.2467 8.96833 13.5317C9.25333 13.8161 9.59722 13.9584 10 13.9584ZM7.5 7.08335H12.5V5.41669C12.5 4.72224 12.2569 4.13196 11.7708 3.64585C11.2847 3.15974 10.6944 2.91669 10 2.91669C9.30556 2.91669 8.71528 3.15974 8.22917 3.64585C7.74306 4.13196 7.5 4.72224 7.5 5.41669V7.08335Z",
    fill: "#252525"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.18f882748274025bd1e2f82fa48fce24.svg";
export { ForwardRef as ReactComponent };